/**
 * @generated SignedSource<<e262e79aff863d5bc2a859ca4e2e6952>>
 * @relayHash abde7fd2e5866a4bd80c18b752ee379a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5117800464fb2e71c515f90942a9c849536b618da64f208d685ed536e8eb5176

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraSoftwareListQuery } from './src_jiraSoftwareListQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraSoftwareListQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "5117800464fb2e71c515f90942a9c849536b618da64f208d685ed536e8eb5176",
    "metadata": {},
    "name": "src_jiraSoftwareListQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
